import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import { AddonDetails } from "@features/Addons/AddonDetails";
import { useTranslation } from "react-i18next";
import { useAddonsPage } from "./useAddonsPage";
import { SectionTitle } from "@common/SectionTitle/SectionTitle";
import { ACCOUNT_DETAILS_PAGE_URL } from "@constants";

export const AddonsPage = () => {
    const { t } = useTranslation("addons");
    const { addonDetails, getAddonDetails, isLoading, error } = useAddonsPage();

    return (
        <>
            <SubNavigation />
            <div className="container-boxed">
                <SectionTitle
                    backButtonUrl={ACCOUNT_DETAILS_PAGE_URL}
                    subtitle={t("selectAddons")}
                    subtitleVariant="large"
                    title={t("addons")}
                />
                <HandleErrorAndLoading error={error} isLoading={isLoading}>
                    {addonDetails && <AddonDetails addonDetails={addonDetails} getAddonDetails={getAddonDetails} />}
                </HandleErrorAndLoading>
            </div>
        </>
    );
};
